module.exports = __webpack_public_path__ + "3bdbb3cb812c0344a1f906a05671d45b.png";